'use client'

import React from 'react'

import EndImage from '@images/brands/cheongdam/end.png'
import GradientBotImage from '@images/brands/cheongdam/gradient-bot.png'
import LogoWhiteBotImage from '@images/brands/cheongdam/logo-white-bg.png'
import { Box, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'
import Caution from './caution'
import { useResponsive } from '@common/hooks'

const Footer = () => {
  return (
    <VStack data-aos="fade-up" gap={0} spacing={0} position={'relative'}>
      <Caution />
      <Image
        src={GradientBotImage}
        width={1200}
        height={500}
        alt="gradient"
        style={{
          height: '1100px',
          marginTop: '10px',
          width: '100%',
          position: 'relative',
          top: '1px'
        }}
      />
      <Image
        src={EndImage}
        width={1200}
        height={180}
        alt="end"
        style={{
          width: '100%',
          aspectRatio: '1484 / 1048'
        }}
      />
      <VStack
        gap={6}
        style={{
          position: 'absolute',
          top: '900px',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
        width="90%"
      >
        <Image src={LogoWhiteBotImage} width={550} height={180} alt="end" />
        <Text
          textTransform="uppercase"
          color="white"
          fontWeight="bold"
          fontSize={{
            md: 42,
            sm: 34,
            base: 22
          }}
          textAlign="center"
        >
          Black change shampoo
        </Text>
      </VStack>
    </VStack>
  )
}

export default Footer
